export function setUploadFilePolicy(policy) {
  return {
    type: 'SET_POLICY_FOR_UPLOAD_FILE',
    payload: { policy },
  }
}

export function setUploadFilePreviousPolicy(previousPolicy) {
  return {
    type: 'SET_UPLOAD_FILE_PREVIOUS_POLICY',
    payload: { previousPolicy },
  }
}

export function setForceResetOnMount(forceResetOnMount) {
  return {
    type: 'SET_FORCE_RESET_ON_MOUNT',
    payload: { forceResetOnMount },
  }
}

export function setIsUploadCategoryOpen(isOpen) {
  return {
    type: 'SET_IS_UPLOAD_CATEGORY_OPEN',
    payload: { isOpen },
  }
}

export function setUploadCategory(uploadCategory) {
  return {
    type: 'SET_UPLOAD_CATEGORY',
    payload: { uploadCategory },
  }
}

export function setShortNote(shortNote) {
  return {
    type: 'SET_SHORT_NOTE',
    payload: { shortNote },
  }
}

export function addFile(file) {
  return {
    type: 'ADD_FILE',
    payload: { file },
  }
}

export function removeFile(uid) {
  return {
    type: 'REMOVE_FILE',
    payload: { uid },
  }
}

export function resetUploadFile() {
  return {
    type: 'RESET_UPLOAD_FILES',
  }
}

export function resetAllExceptPolicies() {
  return {
    type: 'RESET_ALL_EXCEPT_POLICIES',
  }
}

export function submitFileUpload(data) {
  return {
    type: 'SEND_FILE_UPLOAD',
    payload: data,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/uploads/storeFiles',
          },
        },
        commit: {
          type: 'SEND_FILE_UPLOAD_COMMIT',
        },
        rollback: {
          type: 'SEND_FILE_UPLOAD_ROLLBACK',
        },
      },
    },
  }
}
